import { HEADER_HEIGHT } from '@/presentation/components/Header/styles';
import { DealBody, MediaQuery, Theme } from '@pelando/components';
import { styled } from 'styled-components';

export const Container = styled.div`
  scroll-margin-top: ${HEADER_HEIGHT}px;
  background-color: rgb(${Theme.colors.Kilo});
  border-top: 4px solid rgb(${Theme.colors.Juliet});
  padding: 16px;

  @media ${MediaQuery.SCREEN_LG_UP} {
    border: 1px solid rgb(${Theme.colors.Golf});
    background-color: rgb(${Theme.colors.Juliet});
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 16px 24px;
    min-height: 708px;
  }
`;

export const Description = styled(DealBody)`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
`;

export const HeaderContainerSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12px 0;
`;
